"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationScreenCont = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.RegistrationScreenCont = styled_components_1.default.div `
  label div {
    border: 1px dashed #d2d2d2;
    width: 60px;
    height: 60px;
  }
    .fakeRadioButtonWrapper {
        padding:16px 8px;
        .fakeRadioButton {
            width: 18px;
            height: 18px;
            margin-top: 3px;
            padding:2px;
            span {
                width: 12px;
                height: 12px;
            }
        }
    }
    .fakeRadioButtonWrapper.active {
        transition: outline 0.1s ease, border-color 0.1s ease;
        outline: 2px solid #0061fe ;
        border-color :#0061fe;
        .fakeRadioButton{border-color :#0061fe !important}
    }
`;
